export const DEFAULT_OFFER_PER_PAGE: number = 21;
